"use strict";

exports.__esModule = true;
var _EnvContext = require("./EnvContext");
Object.keys(_EnvContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EnvContext[key]) return;
  exports[key] = _EnvContext[key];
});
var _Locale = require("./Locale");
Object.keys(_Locale).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Locale[key]) return;
  exports[key] = _Locale[key];
});